import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://api.leaderbored.gg/api",
  // baseURL: "https://leaderbored-api.taktylstudios.com/api",
  // headers: {
  //   'Accept-Encoding': 'gzip, deflate, br'
  // }
});

export default axiosInstance;
